import React from 'react';
import { motion } from 'framer-motion';
import { TargetIcon, BarChart3Icon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
export function WhyChooseUs() {
  const benefits = [{
    title: 'ROI Focused',
    description: "We don't care about vanity metrics. We care about leads, sales, and your bottom line.",
    icon: TargetIcon
  }, {
    title: 'Transparent Reporting',
    description: "24/7 access to live dashboards. Know exactly where every dollar is going and what it's returning.",
    icon: BarChart3Icon
  }, {
    title: 'Dedicated Team',
    description: 'No junior account managers. You work directly with seasoned marketing experts.',
    icon: ShieldCheckIcon
  }, {
    title: 'Custom Strategies',
    description: 'No cookie-cutter templates. We build bespoke campaigns tailored to your specific market.',
    icon: ZapIcon
  }];
  return <section className="py-24 bg-gray-50 border-y border-gray-100" data-id="element-678" data-mp="25kghmxaepyta">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-679" data-mp="1ndc6b6kh95wh">
        <div className="lg:grid lg:grid-cols-12 lg:gap-16 items-center" data-id="element-680" data-mp="1ig3nd3ri8xu6">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="lg:col-span-5 mb-12 lg:mb-0" data-id="element-681" data-mp="1idpsauwtrlmm">
            <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-6 tracking-tight" data-id="element-682" data-mp="zj2fnb6kgjmj">
              Why partner with <span className="text-red-600" data-id="element-683" data-mp="19f5h0etlge8f">AdROI</span>?
            </h2>
            <p className="text-lg text-gray-600 mb-8" data-id="element-684" data-mp="19gyrk57bvilp">
              We operate as an extension of your business. Our goal isn't just
              to run ads—it's to build a sustainable, scalable revenue engine
              for your company.
            </p>
            <button className="bg-gray-900 hover:bg-gray-800 text-white px-8 py-4 rounded-md font-bold text-lg transition-all shadow-md hover:shadow-lg" data-id="element-685" data-mp="2rw7gwiz4rfb6">
              Meet The Team
            </button>
          </motion.div>

          <div className="lg:col-span-7" data-id="element-686" data-mp="31w6mq8460rkc">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-8" data-id="element-687" data-mp="36u85st1lcqvt">
              {benefits.map((benefit, index) => <motion.div key={index} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: index * 0.1
            }} className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100" data-id="element-688" data-mp="297izw83rpu4o" data-mpi={index}>
                  <div className="w-12 h-12 bg-red-50 rounded-lg flex items-center justify-center mb-4" data-id="element-689" data-mp="cki3pd09hkyv">
                    <benefit.icon className="w-6 h-6 text-red-600" data-id="element-690" data-mp="8jog6kqqe86i" />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-691" data-mp="3iqxm71t7c4h">
                    {benefit.title}
                  </h3>
                  <p className="text-gray-600" data-id="element-692" data-mp="3upbnhng4odzx">{benefit.description}</p>
                </motion.div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}